<div class="main_catalogues_sec">

  <div class="wrapper">
    <section class="banner-container" style="border-radius: 20px;" *ngIf="selectedCourse?.course_banner_image?.length">
      <div class="banner-swiper">
        <div class="banner-wrapper" style="padding: 20px 0;border-radius: 20px;">

          <swiper [config]="headerBannerSwiperConfig" class="banner-swiper">
            <div *ngFor="let banner of selectedCourse?.course_banner_image" class="swiper-slide">
              <div class="banner-wrapper">
                <img class="banner-image" style="border-radius: 20px;" [src]="banner?.url" />

              </div>
            </div>

            <div class="swiper-pagination"></div>
          </swiper>

        </div>

      </div>
    </section>
  </div>


  <div class="wrapper">
    <div class="full-white-background">

      <div fxLayout="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
        fxLayoutAlign="start stretch" fxLayoutGap="8px">
        <div fxLayout="column" fxFlex="100" fxFlexFill>
          <div class="wrapper">
            <div class="top-bred-crumb">
              <ul class="breadcrumb">
                <li [routerLink]="['/index']" class="breadcrumb-item">
                  <a>Home</a>
                </li>

                <li class="breadcrumb-item" [routerLink]="['/learning/learning-hub']" style="cursor: pointer;">
                  <a>All Courses</a>
                </li>
                <li class="breadcrumb-item">
                  <a style="color: #FF7000 !important"> Course Details</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="job-details-page">
        <div class="job-details-page__container">

          <!-- Left Sidebar -->

          <aside class="job-details-sidebar">
            <div class="related-header">
              <h3 class="job-details-sidebar__title">Related Courses</h3>


              <!-- View All Link -->
              <span [routerLink]="['/learning/learning-hub']" class="viewall">View all <span> > </span></span>
            </div>
            <!-- Job cards -->
            <div class="related-course customeScroll scrollable-list" infiniteScroll [infiniteScrollDistance]="2"
              [infiniteScrollThrottle]="150" [scrollWindow]="false" (scrolled)="loadMoreCourses()">
              <div class="talent-container">
                <ng-container *ngFor="let courseRelate of allRelatedCoursesData; let i = index; trackBy: trackByCourse">
                  <!-- Talent Card -->
                  <div class="course-card" [routerLink]=" ['/learning/learning-hub-details', courseRelate?.id ]">

                    <div class="course-banner-rela">
                      <!-- <img  [src]="courseRelate?.presented_by_image?.url"  /> -->
                      <swiper [config]="relatedCourseSwiperConfig">
                        <div *ngFor="let relatedImg of courseRelate?.course_banner_image" class="swiper-slide">
                          <img [src]="relatedImg?.url" alt="relatedImg" />
                        </div>
                      </swiper>
                    </div>

                    <div class="course-details-rela">


                      <div class="course-name-relas">
                        <div> {{courseRelate?.type}}

                        </div>
                      </div>
                      <div class="course-name-rela">
                        <div> {{courseRelate?.course_name}}
                          A Comprehensive Guide
                        </div>
                      </div>



                      <div class="presenter-rela">
                        <div> <img class="presenter-img-rela" [src]="courseRelate?.presented_by_image?.url"
                            alt="User banner" /> </div>
                        <div class="presenter-name-rela">{{ courseRelate?.presented_by_name }} </div>
                      </div>


                      <hr>

                      <div class="event-details-rela">
                        <div class="info">
                          <div class="date">
                            <mat-icon>event</mat-icon>
                            <span>{{courseRelate?.startDate }}</span>
                          </div>
                          <div class="location" *ngIf="courseRelate?.address">
                            <mat-icon>place</mat-icon>
                            <span>{{courseRelate?.address}} </span>
                          </div>
                        </div>

                        <div class="course-link" [routerLink]=" ['/learning/learning-hub-details', courseRelate?.id ]">
                          <button mat-icon-button class="black-circle-btn">
                            <mat-icon>north_east</mat-icon>
                          </button>

                        </div>

                      </div>

                    </div>



                  </div>
                  <!-- Sponsored Card Logic -->
                  <div *ngIf="leftNavBannerData?.length">
                    <div
                      *ngIf="(allRelatedCoursesData?.length > 0) && (((i + 1) % 3 === 0) || (allRelatedCoursesData?.length <= 3))"
                      class="custom-sponsored-card">

                      <section class="banner-container" *ngIf="leftNavBannerData?.length">
                        <swiper [config]="leftNavRandomSwiperConfig(i)" class="banner-swiper">
                          <div *ngFor="let banner of leftNavBannerData" swiperSlide #leftNavSlide>
                            <div class="banner-wrapper">

                              <a [href]="banner.url" target="_blank" rel="noopener noreferrer">
                                <img class="banner-imageLeft" [src]="banner.img?.url" [alt]="banner.img.name" />
                              </a>

                              <div class="sponsored-label">
                                <span class="info-icon">i</span> Sponsored
                              </div>
                            </div>
                          </div>

                          <div class="swiper-pagination"></div>
                        </swiper>
                      </section>

                    </div>
                  </div>
                </ng-container>

                <div *ngIf="dataLoaded && allRelatedCoursesData?.length === 0">
                  <div *ngIf="leftNavBannerData?.length" class="custom-sponsored-card">

                    <section class="banner-container" *ngIf="leftNavBannerData?.length">
                      <swiper [config]="leftNavDynamicSwiperConfig()" class="banner-swiper">
                        <div *ngFor="let banner of leftNavBannerData" swiperSlide #leftNavSlide>
                          <div class="banner-wrapper">

                            <a [href]="banner.url" target="_blank" rel="noopener noreferrer">
                              <img class="banner-imageLeft" [src]="banner.img?.url" [alt]="banner.img.name" />
                            </a>

                            <div class="sponsored-label">
                              <span class="info-icon">i</span> Sponsored
                            </div>
                          </div>
                        </div>

                        <div class="swiper-pagination"></div>
                      </swiper>
                    </section>

                  </div>
                </div>

              </div>
            </div>
          </aside>

          <!-- Main Content -->
          <main class="job-details-content" *ngIf="selectedCourse">
            <!-- ...existing code... -->

            <div class="header-details" style="display: flex; justify-content: space-between; align-items: center;">
              <div>
                <span class="head-title">{{ selectedCourse?.course_name }} <span class="head-title-sub"> A Comprehensive
                    Guide</span> </span>
              </div>

              <div>
                <span class="registered" *ngIf="isRegistered">Already Registered</span>

              </div>
            </div>
            <hr>

            <div class="presenter-container">
              <div class="presenter-info">
                <span class="label">Presented by</span>

                <div style="display: flex;align-items: center;gap: 10px;">
                  <div class="presenter-image">
                    <img *ngIf="selectedCourse?.presented_by_image?.url" [src]="selectedCourse?.presented_by_image?.url"
                      alt="Presenter" />
                  </div>
                  <div>
                    <span class="name"> {{selectedCourse?.presented_by_name}}</span>

                  </div>


                </div>

              </div>

              <div style="display: flex;flex-direction: column;gap: 10px;">
                <ng-container *ngIf="selectedCourse?.startDate && selectedCourse?.endDate">
                  <div class="date-info">
                    <mat-icon class="calendar-icon">event</mat-icon>
                    <div class="time-range">
                      {{ formattedDateRange }}
                    </div>
                  </div>

                </ng-container>
                <ng-container *ngIf="selectedCourse?.startTime && selectedCourse?.endTime">
                  <div class="date-info">
                    <mat-icon class="calendar-icon" aria-hidden="true">access_time</mat-icon>
                    <span class="time-range">
                      {{ selectedCourse?.startTime | date:'hh:mm a' }}
                      &nbsp;–&nbsp;
                      {{ selectedCourse?.endTime | date:'hh:mm a' }}
                    </span>
                  </div>

                </ng-container>

              </div>


            </div>

            <hr>
            <!-- course -- info -->

            <div class="info-container">

              <div class="info-data" style=" justify-content: flex-start;-items: flex-start;">
                <div class="info-item">
                  <div class="info-title">CPD HOURS</div>
                  <div class="info-value">{{selectedCourse?.cpd_points}}</div>
                </div>
              </div>

              <div class="divider"></div>

              <div class="info-data">
                <div class="info-item">
                  <div class="info-title">WHERE</div>
                  <div class="info-value" *ngIf="!selectedCourse?.address">Online</div>
                  <div class="info-value">{{selectedCourse?.city }}</div>
                </div>
              </div>

              <div class="divider"></div>

              <div class="info-data">
                <div class="info-item">
                  <div class="info-title">HOW</div>
                  <div class="info-value">{{selectedCourse?.type}}</div>
                </div>
              </div>

              <div class="divider"></div>

              <div class="info-data" style="justify-content: flex-end; align-items: flex-end;">
                <div class="info-item">
                  <div class="info-title">PRICE</div>
                  <div class="info-value">

                    <!-- Check if afterwards_price is 0 -->
                    <ng-container *ngIf="selectedCourse?.afterwards_price == 0; else priceBlock">
                      <span class="new-price">FREE</span>
                    </ng-container>

                    <!-- Early-bird logic -->
                    <ng-template #priceBlock>
                      <ng-container *ngIf="earlybidPrice(selectedCourse); else afterwardsPrice">
                        <span class="old-price">${{ selectedCourse?.afterwards_price }}</span>
                        <span class="new-price">${{ selectedCourse?.early_bird_price }}</span>
                        <!-- NEW: Early bird end date message -->
                        <div class="early-bird-note" style="font-size: 14px; font-weight: 500;">
                          Early bird Discount Runs Until {{ selectedCourse?.early_bird_end_date | date:'MMM d' }}
                        </div>
                      </ng-container>
                      <ng-template #afterwardsPrice>
                        <span class="new-price">${{ selectedCourse?.afterwards_price }}</span>
                      </ng-template>
                    </ng-template>

                  </div>
                </div>
              </div>


            </div>


            <!-- course image banner -->
            <div class="banner-course-img" style="margin-top: 20px;">

              <div class="swiper-container" *ngIf="selectedCourse?.course_banner_video?.length">
                <swiper [config]="bannerSwiperConfig">
                  <div *ngFor="let img of selectedCourse?.course_banner_video" class="swiper-slide">

                    <img *ngIf="img?.type?.startsWith('image/')" [src]="img?.url" alt="Slide image" loading="lazy" />


                    <div *ngIf="img?.type?.startsWith('video/')" class="video-container">

                      <video #bannerVideo *ngIf="img?.type?.startsWith('video/')" class="" autoplay muted loop
                        preload="metadata">
                        <source [src]="img?.url" type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>

                    </div>



                  </div>
                  <div class="swiper-pagination"></div>
                </swiper>

              </div>
            </div>

            <!-- Objective and topics include -->

            <div class="obj-topics" *ngIf="selectedCourse?.description">

              <div class="objective">
                <div>

                  <h3 class="section-title">Course Description </h3>

                  <div class="underline-wrapper">
                    <div class="underline-orange"></div>
                    <div class="underline-grey"></div>
                  </div>

                  <p class="bio" *ngIf="selectedCourse?.learning_objectives">
                    {{ selectedCourse?.learning_objectives }}
                  </p>


                  <p class="bio" *ngIf="selectedCourse?.description">
                    {{ selectedCourse?.description }}
                  </p>

                </div>

                <div class="event-image" *ngIf="selectedCourse?.course_gallery">
                  <swiper [config]="gallerySwiperConfig">
                    <div *ngFor="let eventimg of selectedCourse.course_gallery" class="swiper-slide">
                      <img [src]="eventimg?.url" alt="eventImg" loading="lazy" />
                    </div>

                  </swiper>
                </div>


              </div>


              <div class="topics-include" *ngIf="selectedCourse?.topics_included">
                <h3 class="section-title">Topics Include </h3>

                <div class="underline-wrapper">
                  <div class="underline-orange"></div>
                  <div class="underline-grey"></div>
                </div>

                <p class="bio">
                  {{ selectedCourse?.topics_included }}
                </p>
              </div>



            </div>


            <!-- course-informarion -->

            <div class="course-information" *ngIf="selectedCourse?.event_type">

              <div class="section-title"> {{selectedCourse?.event_type}} Day Event </div>
              <div class="underline-wrapper">
                <div class="underline-orange"></div>
                <div class="underline-grey"></div>
              </div>

              <div class="course-details" *ngFor="let event of selectedCourse?.course_event_info; let i = index">

                <div class="event-info">
                  <div class="event-title" *ngIf="selectedCourse?.event_type === 'single' "> {{event?.name}} </div>
                  <div class="event-title" *ngIf="selectedCourse?.event_type === 'multiple' "> <span
                      style="color: #ff7a00;font-size:18px"> Day{{i + 1 }}:</span> <span> {{event?.name}} </span> </div>


                  <p class="bio"> {{ event?.info}} </p>

                </div>


                <!-- event image -->
                <div class="event-image" *ngIf="event?.images">
                  <swiper [config]="eventSwiperConfig">
                    <div *ngFor="let eventimg of event?.images" class="swiper-slide">
                      <img [src]="eventimg?.url" alt="eventImg" />
                    </div>


                  </swiper>
                </div>

              </div>

            </div>


            <!-- register course -->
            <div id="appointments" class="appointment-container" style="padding-top:30px;">
              <div class="appointment-data">
                <div class="form-wrapper">
                  <h2 class="title">
                    Submit and Register for
                    <span class="highlight-company">{{ selectedCourse?.course_name }}</span>
                  </h2>

                  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                    <div class="form-row">
                      <div class="form-group full-width">
                        <label>First Name<span class="required">*</span></label>
                        <input type="text" placeholder="Enter your first name" formControlName="first_name" />
                        <div class="error" *ngIf="(registerForm.get('first_name')?.touched || submitted) 
                                             && registerForm.get('first_name')?.hasError('required')">
                          First name is required.
                        </div>
                      </div>

                      <div class="form-group full-width">
                        <label>Last Name<span class="required">*</span></label>
                        <input type="text" placeholder="Enter your last name" formControlName="last_name" />
                        <div class="error" *ngIf="(registerForm.get('last_name')?.touched || submitted) 
                                             && registerForm.get('last_name')?.hasError('required')">
                          Last name is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group full-width">
                        <label>Phone Number<span class="required">*</span></label>
                        <input type="tel" placeholder="Enter your phone number" formControlName="phone_number"
                          minlength="10" maxlength="15" />
                        <div class="error" *ngIf="(registerForm.get('phone_number')?.touched || submitted) &&
              registerForm.get('phone_number')?.hasError('required')">
                          Phone number is required.
                        </div>

                        <div class="error" *ngIf="registerForm.get('phone_number')?.hasError('pattern')">
                          Please enter a valid phone number.
                        </div>
                      </div>

                      <div class="form-group full-width">
                        <label>Email<span class="required">*</span></label>
                        <input type="email" placeholder="Enter your email address" formControlName="email" />
                        <div class="error" *ngIf="(registerForm.get('email')?.touched || submitted) 
                                             && registerForm.get('email')?.hasError('required')">
                          Email is required.
                        </div>
                        <div class="error" *ngIf="(registerForm.get('email')?.touched || submitted) 
                                             && registerForm.get('email')?.hasError('email')">
                          Please enter a valid email.
                        </div>
                      </div>
                    </div>


                    <div class="form-row">
                      <div class="form-group full-width">
                        <label>Description</label>
                        <textarea style="border: 1px solid #fff;border-radius: 5px;padding: 8px;"
                          placeholder="Give us more details" formControlName="description" maxlength="500"></textarea>
                      </div>
                    </div>

                    <div class="submit-wrap">
                      <button type="submit">
                        <span class="text">SUBMIT AND REGISTER</span>
                        <span class="arrow-circle-submit"><span class="arrow">&gt;</span></span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>


            <!-- Sponsored By -->

            <div class="sponsored-by" *ngIf="selectedCourse?.sponsor_by_image.length">
              <div class="section-title">Sponsored By</div>

              <div class="underline-wrapper">
                <div class="underline-orange"></div>
                <div class="underline-grey"></div>
              </div>

              <marquee behavior="scroll" direction="left" scrollamount="6">

                <ng-container *ngFor="let SponsorImg of selectedCourse?.sponsor_by_image">
                  <img style="height: 150px;width: 150px;" [src]="SponsorImg?.url" alt="Sponsor" />
                  <span style="display: inline-block; width: 30px;"></span>
                </ng-container>

              </marquee>

            </div>






            <!-- Terms and conditions -->

            <div class="terms-conditions" *ngIf="selectedCourse?.terms">
              <div class="section-title">Terms and Conditions</div>
              <div class="underline-wrapper">
                <div class="underline-orange"></div>
                <div class="underline-grey"></div>
              </div>

              <p class="bio">
                {{ selectedCourse?.terms }}
              </p>


            </div>

            <!-- Cancellation & Refund Policy -->


            <div class="terms-conditions" *ngIf="selectedCourse?.terms">
              <div class="section-title">Cancellation & Refund Policy</div>
              <div class="underline-wrapper">
                <div class="underline-orange"></div>
                <div class="underline-grey"></div>
              </div>

              <p class="bio">
                {{ selectedCourse?.refund_policy}}
              </p>


            </div>


            <!-- contacts -->

            <div id="location" class="location-container" style="padding-top:30px;">

              <div class="section-title">Get in Touch</div>

              <div class="underline-wrapper">
                <div class="underline-orange"></div>
                <div class="underline-grey"></div>
              </div>


              <div class="location-data">

                <div class="contact-wrapper">
                  <!-- Contact Info -->
                  <div class="contact-info">
                    <div class="info-block" *ngIf="selectedCourse?.address">
                      <div class="icon-circle">
                        <img src="../../../../../assets/images/icons/location-directory.png"
                          style="height: 20px !important; width: 16px;" alt="Location Icon" class="icon" />
                      </div>
                      <p> {{selectedCourse?.address}}</p>
                    </div>

                    <div class="info-block" *ngIf="selectedCourse?.contact_email">
                      <div class="icon-circle">
                        <img src="../../../../../assets/images/icons/mail-directory.png" alt="Email Icon"
                          class="icon" />
                      </div>
                      <p> {{selectedCourse?.contact_email}} </p>
                    </div>

                    <div class="info-block" *ngIf="selectedCourse?.contact_phone ">
                      <div class="icon-circle">
                        <img src="../../../../../assets/images/icons/call-directory.png" alt="Phone Icon"
                          class="icon" />
                      </div>
                      <p> {{selectedCourse?.contact_phone}}</p>
                    </div>

                    <div class="info-block" *ngIf="selectedCourse?.contact_website">
                      <div class="icon-circle">
                        <i style="color: white;" class="fas fa-globe"></i>
                      </div>
                      <a class="socialLink" href="https://www.example.com " target="_blank">
                        {{selectedCourse?.contact_website}}
                      </a>

                    </div>

                  </div>

                  <!-- Map -->
                  <div class="map-section" *ngIf="selectedCourse?.address">
                    <agm-map [latitude]="lat" [longitude]="lng">
                      <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
                    </agm-map>
                  </div>

                </div>

              </div>




            </div>


          </main>

        </div>
      </div>
    </div>

  </div>
  <div class="chat-popup-container" *ngIf="showPopup">
    <div class="chat-popup animate-popup">
      <div class="chat-header">
        <span style="color: #ff7000;">Successfuly Registered</span>
        <button mat-icon-button class="close-btn" (click)="closeChatPopup()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="chat-body">
        <p>You are being redirected to the registration Link ...</p>
      </div>

      <div class="chat-input">
        <button class="link-btn" (click)="confirmRegistration()">
          Ok
        </button>
      </div>
    </div>
  </div>

</div>